import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_KEY = 'duel:notification_prefs';

export interface NotificationPrefs {
  duelUpdates: boolean;
  freshnessReminders: boolean;
  prCelebrations: boolean;
  coachMessages: boolean;
}

const DEFAULTS: NotificationPrefs = {
  duelUpdates: true,
  freshnessReminders: true,
  prCelebrations: true,
  coachMessages: true,
};

export async function getNotificationPrefs(): Promise<NotificationPrefs> {
  try {
    const raw = await AsyncStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULTS };
  }
}

export async function setNotificationPrefs(
  updates: Partial<NotificationPrefs>,
): Promise<NotificationPrefs> {
  const current = await getNotificationPrefs();
  const merged = { ...current, ...updates };
  await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  return merged;
}
